const blockCustomerKnowHow = {

    // the wp block class
    navClass: '.knowhow-index',
    // collection of the <a> elements in the nav
    navItems: null,
    // collection of the sections defined by ID attributes
    sections: null,
    // flag to prevent multiple calls to the update function
    updateCalled: false,

    // init function
    init() {
        // check if the nav exists, exit if not
        const nav = document.querySelector(`${this.navClass}`)
        if (nav === null) {
            this.debug('Nav with this selector not found:', this.navClass)
            return
        }

        this.setSections()

        // exit if no sections are found
        if (this.sections.length === 0) {
            this.debug('No sections found')
            return
        }

        this.setNavItems()

        // exit if no nav items are found
        if (this.navItems.length === 0) {
            this.debug('No nav items found')
            return
        }

        // remove items which targets don't exist
        this.deactivateMissingSections()

        // exit if no items are left
        if (this.navItems.length === 0) {
            this.debug('No nav items left after removing missing targets')
            return
        }

        // initial call to set the active item
        this.update()

        // register the scroll event
        window.addEventListener('scroll', () => this.onScroll())
    },

    debug(...value) {

        if (
            document.location.hostname.indexOf('adwerba') === -1 ||
            document.location.hostname.indexOf('test') === -1 ||
            document.location.hostname.indexOf('localhost') === -1
        ) {
            console.log('[ Know How ]', ...value)
        }

    },


    // look up all sections in the DOM and add a label to them
    setSections() {
        this.sections = document.querySelectorAll('main [id]')
        this.sections.forEach(section => {
            // wir wollen nur IDs mit einem Buchstaben
            if (section.id.length !== 1) return

            section.classList.add('relative')
            section.prepend(this.createSectionPseudo(section.id))
        })
    },

    // adds the label to the section
    createSectionPseudo(letter) {
        const pseudo = document.createElement('span')
        pseudo.textContent = letter
        pseudo.classList.add('static', 'xl:sticky', 'text-xxl', 'md:text-[80px]', 'text-primary', 'top-40')
        return pseudo
    },

    // look up all nav links in the DOM
    setNavItems() {
        this.navItems = document.querySelectorAll(`${this.navClass} a`)
    },

    // deactivate items which targets don't exist
    deactivateMissingSections() {
        this.navItems.forEach(item => {
            const target = document.getElementById(this.getItemTarget(item))
            if (!target) {
                // deactivate the item
                item.classList.add('pointer-events-none', 'border-white', 'hidden', 'lg:flex')
                this.debug('Page section not found, nav item deactviated:', this.getItemTarget(item))
            }
        })

    },

    // uses requestAnimationFrame to throttle the scroll event 
    onScroll() {
        // prevent multiple calls
        if (this.updateCalled) {
            return
        }

        this.updateCalled = true

        // use requestAnimationFrame to throttle the scroll event
        requestAnimationFrame(() => {
            this.update()
            this.updateCalled = false
        })
    },

    // make an item visible if its target is in the viewport
    update() {
        this.navItems.forEach(item => {
            const target = document.getElementById(this.getItemTarget(item))
            if (target && this.isInViewport(target)) {
                this.setActive(item)
            }
        })
    },

    // set item as active
    setActive(item) {
        const activeClasses = ['bg-primary', 'text-white', 'border-primary']
        const inactiveClasses = ['bg-white', 'text-input-border']
        this.navItems.forEach(item => {
            item.classList.remove(...activeClasses)
            item.classList.add(...inactiveClasses)
            // remove focus and active states of the item
            item.blur()
        })

        item.classList.remove(...inactiveClasses)
        item.classList.add(...activeClasses)
    },

    // check if an element is in the viewport of the current scroll position
    isInViewport(item) {
        const rect = item.getBoundingClientRect()
        // check if more than 50% of the element is visible
        return rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2
    },

    // get the target of an item
    getItemTarget: (item) => item.href.split('#')[1],
}

blockCustomerKnowHow.init()